/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Active from './Active/index'
import Completed from './Completed/index'
import Created from './Created/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/CaptureImageSeries/Content"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let imagesRequestStatusValueData = fromData.useDataValue({ viewPath,
context: 'images_request',
path: 'status',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: imagesRequestStatusValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Created'}>
<Created
  viewPath={`${viewPath}/Created`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Active'}>
<Active
  viewPath={`${viewPath}/Active`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Completed'}>
<Completed
  viewPath={`${viewPath}/Completed`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}